import script from "./myListDetailPage2.vue?vue&type=script&setup=true&lang=js"
export * from "./myListDetailPage2.vue?vue&type=script&setup=true&lang=js"

import "./myListDetailPage2.vue?vue&type=style&index=0&id=5955ad84&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5955ad84"]])

export default __exports__